
import React from 'react'
import { Tabs, message, Button } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import { getSalaryDisplay } from '../com/utils';
import NoData from '../com/NoData';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class mes_info extends React.Component {
  constructor(props) {
    super(props)

    let { type, data } = this.props.location?.data || {}
    this.state = {
      title: type === 'message' ? '消息详情' : '面试邀请',
      data: data || {},
      info:undefined
    }
  }
   componentDidMount() {
    const {data , title}=this.state;
   
    // if (title === '消息详情') {
    //   this.inviteInfo(data);
    // } else{
      this.inviteInfo(data);
    // }
  }

  componentWillUnmount() {
    
  }


  inviteInfo = (data) => {
    const onInviteInfo = (res) => {
      if (res.status == 0) {
        this.setState({ info: res.result });
      }
    }
    WidgetAjax.ajax({ url: path + '/job/interview_info', params: { id: data?.id }, callback: onInviteInfo });

  }



  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }

  onPageChange = () => {

  }

  handleBack = () => {
    this.props.history.goBack();
  };

  interviewConfirm = (data, type) => {
    let params = {
      id: data?.id,
      CONFIRM: type
    }
    const onConfirma = (res) => {
      if (res.status == 0) {
        if (this.props && this.props.onChange) this.props.onChange();
        message.success("操作成功!");

        setTimeout(() => {
          this.handleBack();
        }, 1000);
      }
    }

    WidgetAjax.ajax({ url: path + '/job/interview_confirm', params, callback: onConfirma });
  }


  render() {
    const { title, data , info } = this.state;
    return <div component-data="mes_info">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200'>
            <div className='head_box'>
              <img className='head_return' onClick={this.handleBack} src={require("../../img/pinzhunzhun/dataSource/return.svg")} />
              <div className='head_title'>{title}</div>
            </div>
          </div>
        </div>
        {
          info  && info.id ? 
          <>
                 <div className='mesInfo_box box_1200' >
          <div className='mes_item_card'>
            <div className='job_item_head '>
              <div className='job_info_detail'>
                <div className='job_title' >{info?.JOBNAME}</div>
                <div className='job_salary'>
                  {getSalaryDisplay(info?.SALFROM, info?.SALTO)}
                  {info?.SALPAY == "11" ? "元/小时" : ""}
                  {info?.SALPAY == "12" ? "元/天" : ""}
                  {info?.SALPAY == "13" ? "元/周" : ""}
                </div>
              </div>
              <div className='job_info_detail'>
                <Button type="primary" onClick={() => this.interviewConfirm(info, 6)} >拒绝</Button>
                <Button type="primary" onClick={() => this.interviewConfirm(info, 1)}>接受</Button></div>
            </div>
            <div className='job_tag_box'>
              {info?.DISTRICT_CN ? <div className='job_tag'>{info.DISTRICT_CN}</div> : ""}
              {info?.REQWE_CN ? <div className='job_tag'>{info.REQWE_CN}</div> : ""}
              {info?.REQEDU_CN ? <div className='job_tag'>{info.REQEDU_CN}</div> : ""}
              {!info?.REQAGEFROM && !info?.REQAGETO ? <div className='job_tag'>{'不限年龄'}</div> : ""}
              {info?.REQAGEFROM && !info?.REQAGETO ? <div className='job_tag'>{info.REQAGEFROM + '岁以上'}</div> : ""}
              {!info?.REQAGEFROM && info?.REQAGETO ? <div className='job_tag'>{info.REQAGETO + '岁以内'}</div> : ""}
              {info?.REQAGEFROM && info?.REQAGETO ? <div className='job_tag'>{info.REQAGEFROM + ' - ' + info.REQAGETO + '岁'}</div> : ""}
            </div>

            <div className='ent_box'>
              <img className='ent_logo' src={require("../../img/pinzhunzhun/enterprise/ent-logo.png")} />
              <div className='ent_title' >{info?.ENTNAME}</div>
              <div className='ent_detail'>
                <div className='ellipsis-text' title={info?.INDTYPE_CN}>{info?.INDTYPE_CN ? info?.INDTYPE_CN : null}</div>
                {info?.SCALE_CN ? <div>|</div> : null}
                {info?.SCALE_CN ? info.SCALE_CN : null}
                {info?.ENTTYPE_CN ? <div >|</div> : null}
                {info?.ENTTYPE_CN ? info.ENTTYPE_CN : null}
              </div>
            </div>

          </div>
          <div className='invite_details_box'>
            <div className='invite_title'>
              <img src={require("../../img/pinzhunzhun/dataSource/icon-invite.svg")} />
              亲爱的求职者：
            </div>
            <p className='invite_paragraph'>
              您好！ 感谢您投递该岗位。经过简历初步筛选，我们诚挚邀请您参加面试。具体安排如下：
            </p>
            <p className='invite_paragraph'>
              面试时间：{info?.INTVTIME}
            </p>
            <p className='invite_paragraph'>
              面试岗位：{info?.JOBNAME}
            </p>
            <p className='invite_paragraph'>
              联系人：{info?.INTVCONTACT} {info?.INTVCONTACTTEL}
            </p>
            <p className='invite_paragraph'>
              面试备注：{info?.INTVCOMMENT}
            </p>
            <p className='invite_paragraph'>
              面试地址：{info?.INTVADDR}
            </p>
            <p className='invite_paragraph'>
              我们期待与您进一步交流！
              如有时间冲突，请及时与我们联系调整。
            </p>
            <p>
              祝好！
            </p>
            <p>[{info?.ENTNAME}]HR部门
            </p>
            <p>
              [发布日期：{info?.arranging_time}]
            </p>
          </div>
        </div>
          </>
          :<NoData/>
        }
 
      </div>



    </div>
  }
}

export default mes_info;